export default {
  methods: {
    isAdmin () {
      return this.$auth.user.roles ? Object.values(this.$auth.user.roles).includes('ROLE_ADMIN') : false
    }
  }
}
